<div id='container'>
    <div class='wrap'>
      <ejs-slider 
        id='slider'  
        [tooltip]='tooltip' 
        [value]='value'
        (change)="onSliderChange($event)"
        [min]='min'
        [max]='max'
        [ticks]='slider_ticks' 
        (renderedTicks)='renderedTicks($event)'>
      </ejs-slider>
    </div>
</div>
  